import React from "react";

import { StatusBadgeProps } from "./statusBadgeProps";

export const ReviewStatusBadge = (props: StatusBadgeProps) => {
    const { width, height = "18", viewBox = "0 0 55 18", ...rest } = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox={viewBox}
            {...rest}
            data-cy="reviewBadge"
        >
            <g
                fill="none"
                fillRule="evenodd"
                stroke="none"
                strokeWidth="1"
                transform="translate(-957 -10168) translate(957 10168)"
            >
                <rect
                    width="54.5"
                    height="18"
                    x="0"
                    y="0"
                    fill="#5C4FB0"
                    rx="1.966"
                ></rect>
                <path
                    fill="#FFF"
                    fillRule="nonzero"
                    d="M6 13V5h2.469c1.511 0 2.734.838 2.734 2.31 0 1.036-.657 1.79-1.608 2.078L11.82 13h-1.393l-2.01-3.488c-.152 0-.322.006-.486.006h-.714V13H6zm1.229-4.478h1.347c.9-.029 1.421-.47 1.421-1.19 0-.764-.577-1.24-1.517-1.24H7.229v2.43zM13.168 13V5h5.293v1.121h-4.076v2.31h3.748v1.121h-3.748v2.299h4.076V13h-5.293zm12.167-8h1.336l-3.182 8h-.928l-3.194-8h1.348l2.315 6.047L25.335 5zm2.615 8V5h1.218v8H27.95zm3.443 0V5h5.293v1.121H32.61v2.31h3.748v1.121H32.61v2.299h4.076V13h-5.293zm8.64 0l-2.367-8h1.268l1.784 6.222 1.874-5.77h.956l1.875 5.77L47.212 5h1.262l-2.366 8h-1.19l-1.845-5.628L41.222 13h-1.19z"
                ></path>
            </g>
        </svg>
    );
};
